/* eslint-disable no-unused-vars */
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 React components
import MKBox from "components/MKBox";

// Reusable Components
import CircularPhotoCard from "reusables/Cards/CircularPhotoCard";
import SubTitleContents from "reusables/TextFormats/SubTitleContents";

// Images
import kitchen from "assets/images/Services/Residential/kitchen2.jpg";
import bedroom from "assets/images/Services/Residential/bedroom1.jpg";
import bathroom from "assets/images/Services/Residential/bathroom2.jpg";
import commonArea from "assets/images/Services/Residential/commonArea1.jpg";

const cleaningCategories = [
  {
    image: kitchen,
    name: "Kitchen & Dining Room",
    position: { color: "info", label: "" },
    description: [
      "General tidy-up",
      "Clean and degrease countertops and surfaces",
      "Clean and disinfect sink and faucet",
      "Wipe down dining table and chairs",
      "Clean exterior of appliances (e.g., stovetop, microwave)",
      "Spot-clean cupboard exteriors",
      "Empty bins",
      "Vacuum and mop/steam-clean floors",
    ],
  },
  {
    image: bedroom,
    name: "Bedrooms",
    position: { color: "info", label: "" },
    description: [
      "Make beds and tidy rooms",
      "Dust and remove cobwebs",
      "Wipe down surfaces",
      "Clean and polish mirrors and glass surfaces",
      "Disinfect door handles and light switches",
      "Empty bins",
    ],
  },
  {
    image: bathroom,
    name: "Bathrooms & Toilets",
    position: { color: "info", label: "" },
    description: [
      "General tidy-up",
      "Clean and disinfect countertops, sinks, and faucets",
      "Scrub and sanitize bathtubs and showers",
      "Clean and disinfect toilets",
      "Polish mirrors and glass surfaces",
      "Vacuum and mop floors",
    ],
  },
  {
    image: commonArea,
    name: "Common Areas",
    position: {
      color: "text",
      label: "",
      // label: "Living room, hallways, entryway, and any shared spaces",
    },
    description: [
      "Dusting and wiping surfaces",
      "Vacuuming or mopping floors",
      "Cleaning door handles and light switches",
    ],
  },
];

function Residential_Section4() {
  return (
    <Container>
      <Grid container direction="column" alignItems="center" sx={{ mx: "auto" }} width="100%">
        <Grid item>
          <SubTitleContents
            title="What’s Included in Our Regular Residential Cleaning Services?"
            contents="We understand every home is unique, but we follow a comprehensive cleaning checklist to ensure your space is sparkling clean. Here’s what you can expect from our regular cleaning services:"
          />
        </Grid>
        <Grid item mt={5} width="100%">
          <Grid container spacing={3}>
            {cleaningCategories.map((category, index) => (
              <Grid item xs={12} lg={6} key={index}>
                <MKBox mb={1} height="100%">
                  <CircularPhotoCard
                    image={category.image}
                    icon="check"
                    name={category.name}
                    position={category.position}
                    description={category.description}
                  />
                </MKBox>
              </Grid>
            ))}
          </Grid>
        </Grid>
      </Grid>
    </Container>
  );
}

export default Residential_Section4;
